import React from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';

interface ClipboardValueProps {
    value: string;
    displayValue?: string;
    isDataCentered?: boolean;
    truncateLength?: number;
}

function truncate(value: string, maxLength: number): string {
    if (value.length <= maxLength) return value;
    const sideLength = Math.floor((maxLength - 3) / 2);
    return `${value.slice(0, sideLength)}...${value.slice(-sideLength)}`;
}

export const ClipboardValue: React.FC<ClipboardValueProps> = ({
    value,
    displayValue,
    isDataCentered,
    truncateLength = 12,
}) => {
    const handleCopy = () => {
        toast(`${value} copié`, {
            position: 'top-center',
            hideProgressBar: true,
        });
        navigator.clipboard.writeText(value);
    };

    return (
        <Cell style={{ cursor: 'copy' }} onClick={handleCopy} $isDataCentered={isDataCentered}>
            {displayValue || truncate(value, truncateLength)}
        </Cell>
    );
};

const Cell = styled.span<{ $isDataCentered?: boolean }>`
    display: block;
    text-align: ${({ $isDataCentered }: { $isDataCentered?: boolean }) => ($isDataCentered ? 'center' : 'left')};
`;
